export const DOTS = [
    { id: 0, row: 0, col: 0, active: true },
    { id: 1, row: 0, col: 1, active: true },
    { id: 2, row: 0, col: 2, active: false },
    { id: 3, row: 1, col: 0, active: true },
    { id: 4, row: 1, col: 1, active: false },
    { id: 5, row: 1, col: 2, active: true },
    { id: 6, row: 2, col: 0, active: true },
    { id: 7, row: 2, col: 1, active: true },
    { id: 8, row: 2, col: 2, active: false },
];

export const FAQS = [
    {
        id: "01",
        tag: "Platform",
        question: "What is Clear D?",
        answer: "Clear D is an online B2B partner aggregator platform. We do not own any laboratory equipment — we bring trusted partners together in one transparent ecosystem. For example, Doctor C. Our registered company name is Clear Healthcare Private Limited.",
    },
    {
        id: "02",
        tag: "Brand",
        question: "Why the name Clear?",
        answer: "Our motto is \u201cYour Health, Our Priority\u201d. Clear stands for transparency in our pricing plans and clarity in our goals \u2014 nothing hidden, ever.",
    },
    {
        id: "03",
        tag: "Leadership",
        question: "Who is Clear?",
        answer: "Clear is led by 4 leaders: Srinivas CI and Uday PM as Co-Founders, and Swetha (Homemaker) and Rekha (Dentist) as Co-CEOs \u2014 a family team with a long-term vision.",
    },
    {
        id: "04",
        tag: "Launch",
        question: "When is Clear launching?",
        answer: "Our target is to launch the mobile app on both Android & Apple stores, together with the website, on 26-December-2027 \u2014 a date chosen to celebrate both wives\u2019 birthdays.",
    },
    {
        id: "05",
        tag: "Differentiation",
        question: "What is the specialty of Clear D? Why choose Clear D?",
        answer: "Clear D combines unique features from the best applications in the market \u2014 for example, Metropolis-style sample collector live map tracking, and MediBuddy-style curation of test packages based on organs or health parameters \u2014 all in one place.",
    },
    {
        id: "06",
        tag: "Objective",
        question: "What is your agenda or objective?",
        answer: "Not making money. Clear D is an educational service built for the long term \u2014 10 to 20 years of generational sustainability for our daughters.",
    },
    {
        id: "07",
        tag: "Strategy",
        question: "What is your market strategy?",
        answer: "Organic GTM (Go-To-Market) strategy \u2014 not quick viral growth that can\u2019t be scaled or sustained. Our budget is limited because we are a self-funded, bootstrapped family & friends startup, with no investors or sponsorships for now.",
    },
    {
        id: "08",
        tag: "Growth",
        question: "How do you make people move to your app?",
        answer: "We won\u2019t steal customers from others. If our product is robust, we will gain market share slowly \u2014 trust is earned, not taken.",
    },
    {
        id: "09",
        tag: "Budgets",
        question: "What are your IT and marketing budgets?",
        answer: "IT: Rs. 5 per order on top of operating server costs, plus a one-time Rs. 5 lakhs development cost. Marketing: Rs. 10 per order \u2014 mathematically calculated from the average order volume across our 2 launch zones.",
    },
    {
        id: "10",
        tag: "Rollout",
        question: "Where are you launching, and how big is the team?",
        answer: "Initially 2 zones in Hyderabad: Kukatpally (headquartered at V.V. Nagar) and the Hi-tec City cosmopolitan crowd, with PIN-code based geotagging inside the mobile app. Team per zone: 2 administrative staff, 1 marketing lady, and 3\u20134 sample collection boys.",
    },
];

export const MARQUEE_ITEMS = [
    "Your Health, Our Priority",
    "Transparent Pricing",
    "Clarity in Goals",
    "Launching 26 · 12 · 2027",
    "Kukatpally · Hi-tec City",
    "Self-funded Family Startup",
    "Clear Healthcare Private Limited",
];
